export default __webpack_public_path__ + "static/media/Home-EN.714f0256.png";